import React from "react";
import Grid from "@material-ui/core/Grid";
import { Box, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
// import MediaAddedReport from "../creator-application/dashboard/MediaAddedReport";
// import CSPsReport from "../creator-application/dashboard/CSPsReport";
// import UsersReport from "../creator-application/dashboard/UsersReport";
import OrganizationsReport from "./OrganizationsReport";
import OrganizationsByRoleReport from "./OrganizationsByRoleReport";
import RecentMediaReport from "./RecentMediaReport";
import SolrLoaderReport from "./SolrLoaderReport";

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 350,
    maxWidth: 350,
    width: "100%",
    height: "100%",
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: 20,
    color: theme.palette.secondary.contrastText,
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  reportList: {
    marginTop: theme.spacing(4),
  },
}));

const AdminReportsCard = () => {
  const classes = useStyles();

  return (
    <Card classes={{ root: classes.root }}>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" component="span">
            Quick Stats
          </Typography>
        </Grid>
      </Grid>

      <Box className={classes.reportList}>
        <Grid container direction="column" spacing={3}>
          <Grid item>
            <OrganizationsReport />
          </Grid>
          <Grid item>
            <OrganizationsByRoleReport
              role={"ROLE_PRESSBOOKS_ORGANIZATION"}
              primary="Pressbooks Libraries"
              secondary="Organizations signed up for Pressbooks"
            />
          </Grid>
          <Grid item>
            <SolrLoaderReport />
          </Grid>
          <Grid item>
            <RecentMediaReport />
          </Grid>
          {/*<Grid item>*/}
          {/*  <MediaAddedReport />*/}
          {/*</Grid>*/}
          {/*<Grid item>*/}
          {/*  <CSPsReport />*/}
          {/*</Grid>*/}
        </Grid>
      </Box>
    </Card>
  );
};

export default AdminReportsCard;
